// Frontend-only display constants for the Lashachi Pet clone.
// Core memory flow (pet / observations / memory events) is now served by the
// real backend; only static presentation copy that is out of backend scope
// lives here.

export const ATTENTION = {
  count: 5,
  summary: [
    '2 need replacing',
    "1 doesn't fit",
    '1 fit check suggested',
    '1 condition check due',
  ],
};

export const CONFIRM_OPTIONS = [
  { id: 'walk', label: 'Walk' },
  { id: 'potty', label: 'Potty break' },
  { id: 'outing', label: 'Outing' },
  { id: 'other', label: 'Something else' },
];
